function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.667 17.922c0 2.216-5.223 4.012-11.666 4.012-6.443 0-11.666-1.796-11.666-4.012"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.336 18.424v32.098c0 2.216 5.223 4.012 11.666 4.012 6.443 0 11.666-1.796 11.666-4.012V18.424M38.097 13.248c0 1.729-4.52 3.13-10.095 3.13-5.576 0-10.095-1.401-10.095-3.13 0-1.497 3.391-2.75 7.922-3.057m4.706.026c4.35.349 7.563 1.573 7.563 3.031"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.949,
  cy: 13.917,
  rx: 2.425,
  ry: 0.978
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.3 17.922l1.867-3.572M37.837 14.35l1.867 3.572"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.735 4.619c0 2.814-1.493 3.752-1.764 7.253-.094 1.214-1.246 1.043-1.969 1.043-.706 0-1.828.2-1.93-.977-.31-3.567-1.803-4.505-1.803-7.32 0-2.59 1.671-3.47 3.733-3.47 2.062 0 3.733.88 3.733 3.47z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.002,
  cy: 8.812,
  rx: 1.12,
  ry: 1.144
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.135,
  y: 2.713,
  width: 3.733,
  height: 2.287,
  rx: 2,
  ry: 2
})), /*#__PURE__*/React.createElement("path", {
  d: "M19 22v28"
})));

var SvgSodacan = function SvgSodacan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSodacan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Soda can.b3d0fa26.svg";
export { ForwardRef as ReactComponent };